import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {runtimeEventManager, switchClass} from "@wm/core";

const DEFAULT_CLS = 'alert app-message';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-message',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmMessage]',
  template: `<i aria-hidden="true" [title]="type + 'Alert'" class="icon {{type}} {{messageIconClass}}"></i>
  <span [innerHtml]="caption" style="padding-left: 30px"></span>
  <button title="Close" type="button" class="btn-transparent close" [hidden]="hideclose" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>`,
  providers: [
    provideAsWidgetRef(MessageComponent)
  ],
  exportAs: 'wmMessage',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class MessageComponent extends StylableComponent {
  static initializeProps = register('wm-message');
  messageClass: string | any = '';
  messageIconClass: string | any = '';
  type = '';
  caption: string;
  public hideclose: any;
  protected isPrism: boolean = false;


  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    const projectService = runtimeEventManager.getService('projectService');
    this.isPrism = projectService.isPrism();
    if (this.isPrism) this.messageIconClass = 'fa';
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'type' && !this.isPrism) {
      this.onMessageTypeChange(nv);
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  private onMessageTypeChange(nv: string) {
    let msgCls, msgIconCls;
    switch (nv) {
      case 'success':
        msgCls = 'alert-success';
        msgIconCls = 'wm-sl-l sl-check';
        break;
      case 'error':
        msgCls = 'alert-danger';
        msgIconCls = 'wi wi-cancel';
        break;
      case 'warn':  /*To support old projects with type as "warn"*/
      case 'warning':
        msgCls = 'alert-warning';
        msgIconCls = 'wm-sl-l sl-alarm-bell';
        break;
      case 'info':
        msgCls = 'alert-info';
        msgIconCls = 'wi wi-info';
        break;
      case 'loading':
        msgCls = 'alert-info alert-loading';
        msgIconCls = 'fa fa-spinner fa-spin';
        break;
    }
    switchClass(this.nativeElement, msgCls, this.messageClass);
    this.messageClass = msgCls;
    this.messageIconClass = msgIconCls;
  }

}

